import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { select, Store } from '@ngrx/store';
import { Company } from 'app/api/company.api.service';
import { AppState } from 'app/reducers';
import { AmplifyService } from 'aws-amplify-angular';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CompaniesUISelectors, CompanySelectors, CompaniesSelectors } from './selectors';

@Component({
    selector   : 'company',
    templateUrl: './company.component.html',
    styleUrls  : ['./company.component.scss'],
    animations   : fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class CompanyComponent implements OnInit, OnDestroy {
    currentCompany$: Observable<Company>;
    loading$: Observable<boolean>;

    // Protected
    protected logger: any;

    // Private
    private _unsubscribeAll: Subject<any>;
    
    constructor(
        protected amplifyService: AmplifyService,
        protected store: Store<AppState>
    ) {
        this.logger = this.amplifyService.logger('CompanyComponent');
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.loading$ = this.store.pipe(select(CompanySelectors.selectCompanyLoading));
        this.currentCompany$ = this.store.pipe(select(CompaniesSelectors.selectCurrentCompany));
        this.store
        .pipe(
            takeUntil(this._unsubscribeAll),
            select(CompaniesUISelectors.selectCurrentCompanyId),
        )
        .subscribe(companyId => {
            window.history.pushState({}, '', `/company/${companyId}`);
        });

    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}

